import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';

interface BackConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  activeStep: number;
}

const BackConfirmDialog: React.FC<BackConfirmDialogProps> = ({
  open,
  onClose,
  onConfirm,
  activeStep,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirm Navigation</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {activeStep >= 3
            ? 'This action will discard your current analysis results. Are you sure you want to go back?'
            : 'Unsaved changes may be lost. Continue?'}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onConfirm} color="error">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BackConfirmDialog;